export default "__VITE_ASSET__tmgsg7b8__"